import React, { useCallback, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Text, Radio } from '@ui';
import { translate } from '@utils/i18n';
import './AssessmentFeedbackModalStyles.scss';
const NS = 'features.iim_review.ai_summary_banner.feedback';
const REASON_CODES = [
    'priority_too_high',
    'priority_too_low',
    'counts_inaccurate',
    'grouped_incorrectly',
    'missed_an_issue',
    'flagged_non_issue',
    'other'
];
export default function AssessmentFeedbackModal({ isOpen, onClose, onSubmit }) {
    const [selectedReason, setSelectedReason] = useState(null);
    const [details, setDetails] = useState('');
    const handleClose = useCallback(() => {
        setSelectedReason(null);
        setDetails('');
        onClose();
    }, [onClose]);
    const handleSubmit = useCallback(() => {
        if (!selectedReason)
            return;
        onSubmit(selectedReason, details || undefined);
        setSelectedReason(null);
        setDetails('');
    }, [selectedReason, details, onSubmit]);
    const titleId = 'assessment-feedback-modal-title';
    const radioOptions = REASON_CODES.map((code) => ({
        value: code,
        label: translate(`reason_codes.${code}`, { namespace: NS })
    }));
    return (React.createElement(Modal, { isOpen: isOpen, onClose: handleClose, ariaLabelledBy: titleId, className: "assessment-feedback-modal" },
        React.createElement(ModalHeader, { title: translate('modal_title', { namespace: NS }), onClose: handleClose, titleId: titleId }),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "assessment-feedback-modal__body" },
                React.createElement(Text, { variant: "body", as: "p", className: "assessment-feedback-modal__description" }, translate('modal_body', { namespace: NS })),
                React.createElement(Radio, { name: "assessment_reason_code", options: radioOptions, value: selectedReason !== null && selectedReason !== void 0 ? selectedReason : '', onChange: (v) => {
                        const code = v;
                        setSelectedReason(code);
                        if (code !== 'other')
                            setDetails('');
                    } }),
                selectedReason === 'other' && (React.createElement("textarea", { className: "assessment-feedback-modal__details", value: details, onChange: (e) => setDetails(e.target.value), placeholder: translate('details_placeholder', { namespace: NS }), rows: 3, "aria-label": translate('details_placeholder', { namespace: NS }) })))),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { onClick: handleClose }, translate('cancel', { namespace: NS })),
            React.createElement(Button, { variant: "primary", onClick: handleSubmit, disabled: !selectedReason }, translate('submit', { namespace: NS })))));
}
